import { BASEPATH } from "../../../utils/constants/constants";

export const SCRT_REPORT_MANAGEMENT_URL = {
  GET_ALL_REPORTS: `${BASEPATH}/reports/getAllReports`,  
  DELETE_REPORTS: `${BASEPATH}/reports/manageReports`,
  SEND_TO_ERP: `${BASEPATH}/reports/manageReports`,
};